module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.expanded) ? _c('div', {
    staticClass: "fake-youtube-container",
    on: {
      "click": function($event) {
        _vm.expanded = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": ("https://img.youtube.com/vi/" + _vm.videoCode + "/0.jpg")
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-youtube-play fa-stack-1x"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-youtube-play fa-stack-1x"
  })]) : _vm._e(), _vm._v(" "), (_vm.expanded) ? _c('div', {
    staticClass: "youtube-iframe-wrapper"
  }, [_c('iframe', {
    staticClass: "real-youtube-container",
    attrs: {
      "src": ("https://www.youtube.com/embed/" + _vm.videoCode + "?autoplay=1"),
      "frameborder": "0",
      "allowfullscreen": ""
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b26d8cf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Common/FakeYoutube.vue
// module id = 389
// module chunks = 1